var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-sidesheet",
    {
      attrs: {
        id: "inventory-category-modal",
        title: _vm.title,
        active: _vm.active,
      },
      on: { close: _vm.close },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c("c-button", {
                attrs: { label: "Отменить", size: "large" },
                on: { click: _vm.close },
              }),
              _c("c-button", {
                attrs: {
                  label: "Сохранить",
                  color: "primary",
                  size: "large",
                  disabled: _vm.pending,
                  pending: _vm.pending,
                },
                on: { click: _vm.submit },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.loading
        ? _c("div", [_vm._v("Loading...")])
        : _c("div", { staticClass: "inventory-category" }, [
            _c("div", { staticClass: "inventory-category__form" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col col-xl-6" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group inventory-category__name",
                      class: {
                        "is-invalid": _vm.isSubmitted && _vm.nameError,
                      },
                    },
                    [
                      _c("c-input", {
                        attrs: {
                          "floating-label": "Наименование",
                          clearable: true,
                          "max-length": 500,
                          "required-mark": true,
                          required: _vm.isSubmitted && _vm.nameError,
                          "required-message": _vm.isSubmitted && _vm.nameError,
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col col-xl-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-group inventory-category__category" },
                    [
                      _c("c-input", {
                        attrs: {
                          type: "select",
                          items: _vm.categoriesList,
                          label: "Местоположение",
                          placeholder: "Верхний уровень",
                          clearable: true,
                          searchable: true,
                        },
                        model: {
                          value: _vm.form.parentId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "parentId", $$v)
                          },
                          expression: "form.parentId",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col col-xl-6" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group inventory-category__responsible",
                    },
                    [
                      _c("c-input", {
                        attrs: {
                          type: "select",
                          items: _vm.workersList,
                          "floating-label": "Ответственный",
                          clearable: true,
                          searchable: true,
                          "with-categorized": true,
                        },
                        model: {
                          value: _vm.form.responsible,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "responsible", $$v)
                          },
                          expression: "form.responsible",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col col-xl-10" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group inventory-category__description",
                    },
                    [
                      _c("c-textarea", {
                        attrs: {
                          clearable: true,
                          "floating-label": "Описание",
                          "max-length": "500",
                        },
                        model: {
                          value: _vm.form.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "description", $$v)
                          },
                          expression: "form.description",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col col-xl-10" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group inventory-category__link",
                      class: {
                        "is-invalid": _vm.isSubmitted && _vm.linkError,
                      },
                    },
                    [
                      _c("c-input", {
                        attrs: {
                          "floating-label": "Ссылка",
                          clearable: true,
                          "max-length": 500,
                          required: _vm.isSubmitted && _vm.linkError,
                          "required-message": _vm.isSubmitted && _vm.linkError,
                        },
                        model: {
                          value: _vm.form.link,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "link", $$v)
                          },
                          expression: "form.link",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "form-group inventory-category__files" },
                [
                  _c("file-loader", {
                    ref: "loader",
                    attrs: {
                      format: "images,pdf,docs,video",
                      actions: "loadFiles,preview",
                      links: _vm.fileLinks,
                      limit: 10,
                    },
                    on: {
                      changeLinks: function ($event) {
                        _vm.fileLinks = $event
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "note",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "note" }, [
                              _vm._v(
                                " Допустимые форматы изображений: .jpeg, .jpg, .gif, .png, видео: .mp4, .avi, .wmv, .mov, .3gp, .flv, .mpeg-1,2, .webm. Размер файла — не более 10Мб. "
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.files,
                      callback: function ($$v) {
                        _vm.files = $$v
                      },
                      expression: "files",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                staticClass: "inventory-category__actions",
                class: {
                  fixed: _vm.fixFooter,
                },
              },
              [
                _c("c-button", {
                  staticClass: "inventory-category__reset",
                  attrs: { label: "Отменить", size: "large" },
                  on: { click: _vm.close },
                }),
                _c("c-button", {
                  staticClass: "inventory-category__save",
                  attrs: {
                    label: "Сохранить",
                    color: "primary",
                    size: "large",
                    disabled: _vm.pending,
                    pending: _vm.pending,
                  },
                  on: { click: _vm.submit },
                }),
                _c("observer", {
                  ref: "observer",
                  staticClass: "footer-observer",
                  on: {
                    fullyVisible: function ($event) {
                      _vm.fixFooter = false
                    },
                    fullyHidden: function ($event) {
                      _vm.fixFooter = true
                    },
                  },
                }),
              ],
              1
            ),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }